import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';
import ActionButtonGradient from '../button/ActionButtonGradient';

const EditConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  onCancel,
  title = "Unsaved Changes",
  message = "You have unsaved changes. Do you want to save your changes as a draft?",
  confirmText = "Save",
  cancelText = "Cancel",
  variant = "primary"
}) => {
  return (
    <>
      <style>
        {`
          .edit-confirmation-modal .modal-content {
            border: none;
            border-radius: 12px;
            box-shadow: 0 10px 25px rgba(0,0,0,0.15);
          }
          .edit-confirmation-modal .modal-header {
            border-bottom: 1px solid #e9ecef;
            padding: 1.5rem 1.5rem 1rem 1.5rem;
            background-color: #fff;
            border-radius: 12px 12px 0 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .edit-confirmation-modal .modal-title {
            font-weight: 600;
            color: #333;
            font-size: 1.125rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            margin: 0;
          }
          .edit-confirmation-modal .modal-body {
            padding: 1rem 1.5rem 1.5rem 1.5rem;
            background-color: #fff;
            font-size: 14px;
            color: #666;
            line-height: 1.5;
            text-align: center;
          }
          .edit-confirmation-modal .modal-footer {
            border-top: 1px solid #e9ecef;
            padding: 1rem 1.5rem 1.5rem 1.5rem;
            background-color: #fff;
            border-radius: 0 0 12px 12px;
            display: flex;
            gap: 0.5rem;
            justify-content: center;
          }
          .edit-confirmation-modal .btn {
            border-radius: 8px;
            padding: 0.5rem 1.25rem;
            font-weight: 500;
            font-size: 14px;
            transition: all 0.2s ease;
          }
          .edit-confirmation-modal .btn-primary {
            background-color: #02B4CC;
            border-color: #02B4CC;
            color: white;
          }
          .edit-confirmation-modal .btn-primary:hover {
            background-color: #028a9e;
            border-color: #028a9e;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(2, 180, 204, 0.3);
          }
          .edit-confirmation-modal .btn-secondary {
            background-color: #6c757d;
            border-color: #6c757d;
            color: white;
          }
          .edit-confirmation-modal .btn-secondary:hover {
            background-color: #5a6268;
            border-color: #545b62;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);
          }
          .warning-icon {
            color: #f39c12;
            font-size: 1.125rem;
          }
        `}
      </style>
      
      <Modal 
        show={show} 
        onHide={onHide} 
        backdrop="static" 
        centered
        size="sm"
        className="edit-confirmation-modal"
      >
        <Modal.Header>
          <Modal.Title>
            <FaExclamationTriangle className="warning-icon" />
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">{message}</p>
        </Modal.Body>
        <Modal.Footer>
          <ActionButtonGradient
            onClick={onCancel||onHide}
            variant='secondary'
            children={cancelText}
          />
          <ActionButtonGradient
            onClick={onConfirm}
            variant={variant}
            children={confirmText}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditConfirmationModal;
